import React, { useRef, useState } from "react";
import "./Conversation.scss";
import CustomButton from "../../shared/custom-button/custom-button";

const Conversation = ({ industryName, conversationSubTitle }) => {
  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    Phone: "",
    Designation: "",
    Organization: "",
    Message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error'
  const formRef = useRef(null);

  const validate = () => {
    const newErrors = {};
    if (!formData.Name.trim()) newErrors.Name = "Name is required";
    if (!formData.Email.trim()) {
      newErrors.Email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.Email)) {
      newErrors.Email = "Email is invalid";
    }
    if (!formData.Phone.trim()) {
      newErrors.Phone = "Phone number is required";
    } else if (!/^\+?[\d\s-]{10,}$/.test(formData.Phone)) {
      newErrors.Phone = "Phone number is invalid";
    }
    if (!formData.Designation.trim())
      newErrors.Designation = "Designation is required";
    if (!formData.Organization.trim())
      newErrors.Organization = "Organization name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    setSubmitStatus(null);

    fetch(
      "https://script.google.com/macros/s/AKfycbwjsq3eyNQtIQTVp-uZdhYihzEDB_w0AxBL8Mjx5HN5nIiuhcIb-6ejmMNL5HqqedM1RQ/exec",
      {
        method: "POST",
        body: new FormData(formRef.current),
      },
    )
      .then((res) => {
        alert("SUCCESSFULLY SUBMITTED");
        setSubmitStatus("success");
        setFormData({
          Name: "",
          Email: "",
          Phone: "",
          Designation: "",
          Organization: "",
          Message: "",
        });
      })
      .catch((error) => {
        console.error("Submission error:", error);
        setSubmitStatus("error");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <section className="conversation-section" id="conversation">
      <div className="container">
        <div className="conversation-left">
          <div className="bg-icon">
            {/* Icon path to be provided later */}
            <img src="/images/industries/conversation.png" alt="" />
          </div>
          <div className="content-wrapper">
            <h2 className="title">Start a Conversation with Our Experts</h2>
            <p className="description">{conversationSubTitle}</p>
          </div>
        </div>

        <div className="conversation-right">
          <div className="form-container">
            <form ref={formRef} onSubmit={handleSubmit} name="google-sheet">
              <div className="form-group">
                <label>Name*</label>
                <input
                  type="text"
                  name="Name"
                  value={formData.Name}
                  onChange={handleChange}
                  placeholder="Enter your full name"
                  className={errors.Name ? "error" : ""}
                />
                {errors.Name && (
                  <span className="error-text">{errors.Name}</span>
                )}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Email*</label>
                  <input
                    type="email"
                    name="Email"
                    value={formData.Email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className={errors.Email ? "error" : ""}
                  />
                  {errors.Email && (
                    <span className="error-text">{errors.Email}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Phone no.*</label>
                  <input
                    type="tel"
                    name="Phone"
                    value={formData.Phone}
                    onChange={handleChange}
                    placeholder="Enter your phone no."
                    className={errors.Phone ? "error" : ""}
                  />
                  {errors.Phone && (
                    <span className="error-text">{errors.Phone}</span>
                  )}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Designation*</label>
                  <input
                    type="text"
                    name="Designation"
                    value={formData.Designation}
                    onChange={handleChange}
                    placeholder="Enter your designation"
                    className={errors.Designation ? "error" : ""}
                  />
                  {errors.Designation && (
                    <span className="error-text">{errors.Designation}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Organization Name*</label>
                  <input
                    type="text"
                    name="Organization"
                    value={formData.Organization}
                    onChange={handleChange}
                    placeholder="Enter organization name"
                    className={errors.Organization ? "error" : ""}
                  />
                  {errors.Organization && (
                    <span className="error-text">{errors.Organization}</span>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label>Your Message</label>
                <textarea
                  name="Message"
                  value={formData.Message}
                  onChange={handleChange}
                  placeholder="Enter your message"
                ></textarea>
              </div>

              {submitStatus === "success" && (
                <div
                  className="submit-message success"
                  style={{ color: "green", marginBottom: "10px" }}
                >
                  Form submitted successfully! We'll get back to you soon.
                </div>
              )}
              {submitStatus === "error" && (
                <div
                  className="submit-message error"
                  style={{ color: "red", marginBottom: "10px" }}
                >
                  Something went wrong. Please try again later.
                </div>
              )}

              <CustomButton
                className="submit-btn"
                variant="primary"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit Now"}
              </CustomButton>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Conversation;
